import { GeoJSONFeatureCollection } from "./api-results.types";
import { get } from "./AureaApi";
import { getOrigin } from "../getUrl";
import { useAuth } from "./auth";

export type ProductFamily = "blossom" | "vigour";

export const BLOSSOM_SKUS = ["TS-BLOSSOM", "OR2"] as const;
export const VIGOUR_SKUS = ["TS-VIGOUR", "OR1"] as const;

export const SKUS_BY_FAMILY: Record<ProductFamily, readonly string[]> = {
  blossom: BLOSSOM_SKUS,
  vigour: VIGOUR_SKUS,
};

export function belongsToFamily(sku: string, family: ProductFamily): boolean {
  return SKUS_BY_FAMILY[family].includes(sku);
}

export type TaskmapHistoryEntry = {
  id: string;
  result_set_id: string;
  customer_id: number;
  field_id: number;
  product_sku: string;
  detection_dates: string[];
  generation_parameters: {
    terminal: { type: string };
    parameters: Record<string, unknown>;
  };
  task_map: GeoJSONFeatureCollection;
  created_at: string;
};

export async function getTaskmapHistory(
  fieldId: string,
): Promise<TaskmapHistoryEntry[]> {
  const result = await get<TaskmapHistoryEntry[]>(
    `/v1/field/${fieldId}/task_map`,
  );

  return result;
}

export async function downloadTaskmap(
  taskmapId: string,
): Promise<Response | null> {
  const token = await useAuth.getState().getToken();
  if (!token) return null;
  return await fetch(`${getOrigin()}/v1/task_map/${taskmapId}/shp`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
